import styled, { css } from 'styled-components';

import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

const tradeInActionButtonStyles = css`
    button {
        width: 112px;
        padding: 8px 0;
        border-radius: 4px;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }
`;

export const TradeInOverviewRoot = styled.div<{ $hasRecord: boolean }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $hasRecord }) => ($hasRecord ? '20px' : '30px')};
`;

export const TradeInOverviewAction = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;

    button {
        width: auto;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            width: 100%;
        }
    }
`;

export const TradeInOverviewInfoRoot = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};
`;

export const TradeInOverviewFields = styled.div`
    display: flex;
    flex: 1 0 0;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
`;

export const TradeInOverviewField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 15px 10px;
    white-space: nowrap;
`;

export const TradeInOverviewVehicle = styled(TradeInOverviewField)`
    flex: 1 0 0;
    min-width: 140px;
    white-space: normal;
    overflow-wrap: anywhere;
`;

export const TradeInOverviewActions = styled.div`
    display: flex;
    gap: 16px;
    margin-left: auto;
    ${tradeInActionButtonStyles}

    @media (max-width: ${BreakPoints.PHONE}) {
        width: 100%;

        button {
            flex: 1 0 0;
        }
    }
`;

export const RemoveTradeInModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    text-align: left;
`;

export const RemoveTradeInModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
    ${tradeInActionButtonStyles}

    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            flex: 1 0 0;
        }
    }
`;
